<h3 mat-dialog-title class="center color-grey">
  {{ 'PROJECT.PROJECT_INFO.CHECKLIST.EDIT_CELL' | anessaTranslation: trigger }}
</h3>

<form #columnForm="ngForm">
  <mat-accordion>

    <mat-expansion-panel *ngIf="!isIcon" [expanded]="cellData.items.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{'PROJECT.PROJECT_INFO.CHECKLIST.DROPDOWN_LIST' | anessaTranslation: trigger}}
        </mat-panel-title>
        <mat-panel-description anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.LIST_OF_ACCEPTED_ITEMS">
        </mat-panel-description>
      </mat-expansion-panel-header>
    
      <ng-container matExpansionPanelContent>
          <div class="item-list">
            <div *ngFor="let item of cellData.items" class="flex-container">
              <p *ngIf="!cellData.items || cellData.items.length === 0" class="item-name">
                {{'PROJECT.COMMON.ADD_ITEMS' | anessaTranslation: trigger}}
              </p>
              <p class="item-name">
                <span
                  *ngIf="isColourHexCode(item) else standardOption"
                  class="coloured-circle"
                  [ngStyle]="{'background-color': item}">
                </span>
                <ng-template #standardOption>
                  {{ item }}
                </ng-template>
              </p>
              <button
                mat-icon-button
                class="item-control"
                color="warn"
                (click)="onRemove(item)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <div class="item-add">
            <hr>
            <form class="flex-container">
              <button
                mat-icon-button
                disableRipple
                type="button"
                class="item-control color-anessa-blue"
                style="padding-top: 18px;"
                [matTooltip]="getPaletteTooltip() | anessaTranslation: trigger"
                color="primary"
                (click)="onToggleColours()">
                <mat-icon>palette</mat-icon>
              </button>
              <mat-form-field class="item-name" appearance="outline" floatLabel="always">
                <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.NEW_ITEM' | anessaTranslation: trigger}}</mat-label>
                <input
                  *ngIf="!isColourInput()"
                  matInput
                  type="text"
                  name="newItemName"
                  [(ngModel)]="newItemName">
                <mat-select
                  *ngIf="isColourInput()"
                  name="newItemName"
                  [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)"
                  [(ngModel)]="newItemName">
                  <mat-select-trigger>
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': newItemName}">
                    </span>
                  </mat-select-trigger>
                  <!-- Red -->
                  <mat-option value="#FF0000">
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': '#FF0000'}">
                    </span>
                  </mat-option>
                  <!-- Orange -->
                  <mat-option value="#FF681F">
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': '#FF681F'}">
                    </span>
                  </mat-option>
                  <!-- Yellow -->
                  <mat-option value="#FFFF00">
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': '#FFFF00'}">
                    </span>
                  </mat-option>
                  <!-- Green -->
                  <mat-option value="#00FF00">
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': '#00FF00'}">
                    </span>
                  </mat-option>
                  <!-- Blue -->
                  <mat-option value="#0000FF">
                    <span
                      class="coloured-circle"
                      [ngStyle]="{'background-color': '#0000FF'}">
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button
                mat-icon-button
                disableRipple
                type="submit"
                class="item-control"
                [disabled]="!newItemName"
                style="padding-top: 18px;"
                color="accent"
                (click)="onAdd()">
                <mat-icon>add</mat-icon>
              </button>
            </form>
          </div>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="!isIcon">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{'PROJECT.PROJECT_INFO.CHECKLIST.HINT' | anessaTranslation: trigger}}
        </mat-panel-title>
        <mat-panel-description>
          {{'PROJECT.PROJECT_INFO.CHECKLIST.HINT_DESCRIPTION' | anessaTranslation: trigger}}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <ng-container matExpansionPanelContent>
        <div class="relative-container" (mouseenter)="showClearHint = true" (mouseleave)="showClearHint = false">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.HINT_ENTER' | anessaTranslation: trigger}}</mat-label>
            <input
              matInput
              type="text"
              name="cellPlaceholder"
              [(ngModel)]="placeholderText">
          </mat-form-field>
          <p
            *ngIf="placeholderText && showClearHint"
            class="form-field-clear"
            (click)="placeholderText = ''"
            anessaTranslation="PROJECT.COMMON.CLEAR">
          </p>
        </div>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="isIcon" [expanded]="isIcon">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{'PROJECT.PROJECT_INFO.CHECKLIST.MESSAGE_ICON' | anessaTranslation: trigger}}
          <!-- Message Icon -->
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container matExpansionPanelContent>
        <!-- <form class="relative-container"> -->
          <div class="flex-container">
            <mat-form-field appearance="outline" style="width: 160px; margin-right: 15px;" floatLabel="always">
              <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.ICON' | anessaTranslation: trigger}}</mat-label>
              <mat-select
                matInput
                name="iconTypeSelect"
                [(ngModel)]="iconData.icon"
                #iconSelect
                placeholder="{{'PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger}}"
              >
                <mat-select-trigger>
                  <mat-icon *ngIf="iconData.icon">{{iconData.icon}}</mat-icon>
                  <!-- <ng-template #noneOpt>{{iconSelect.value}}</ng-template> -->
                </mat-select-trigger>
                <mat-option>
                  {{'PROJECT.PROJECT_INFO.CHECKLIST.NONE' | anessaTranslation: trigger}}
                </mat-option>
                <mat-option value="help">
                  <mat-icon>help</mat-icon>
                </mat-option>
                <mat-option value="info">
                  <mat-icon>info</mat-icon>
                </mat-option>
                <mat-option value="error">
                  <mat-icon>error</mat-icon>
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.ENTER_MESSAGE"></mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                name="iconMessageInput"
                type="text"
                [(ngModel)]="iconData.message"
                [required]="iconData.icon">
              </textarea>
            </mat-form-field>
          </div>
        <!-- </form> -->
      </ng-container>
    </mat-expansion-panel>

  </mat-accordion>
</form>

<mat-dialog-actions>
  <button
    [disabled]="!columnForm.valid"
    mat-raised-button
    class="btn-green"
    (click)="onSave()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-raised-button
    class="btn-red"
    color="warn"
    (click)="onCancel()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
